import React, { Component } from 'react';
import LocaleSelector from '../structure/LocaleSelector';
import DateTime from 'react-datetime';
import {FormattedMessage} from "react-intl";

class GeneralTab extends Component {
  forceRefresh(type) {
    this.setState({
      forceRefresh: true
    });

    this.getNewDataMaster(type);
  }

  render() {
    const { currentConfiguration, hasPermission } = this.props;
    const inputProps = {
      name: 'fixedDate',
      disabled: !hasPermission
    };

    return (
      <div className="row">
        <div className="col-md-6">
          <form className="form-horizontal">
            <div className="form-group">
              <label className="col-md-3 control-label">
                <FormattedMessage defaultMessage="Idioma" id="config.language"/>
              </label>
              <div className="col-md-9">
                <LocaleSelector />
              </div>
            </div>

            <div className="form-group">
              <label className="col-md-3 control-label">
                  <FormattedMessage defaultMessage="Actualizar datos maestros" id="config.update.masterdata"/>
              </label>
              <div className="col-md-9">
                <button
                  className="btn btn-default"
                  onClick={() => this.forceRefresh('')}
                >
                  <span className="glyphicon glyphicon-refresh" /> <FormattedMessage defaultMessage="Refresh" id="config.action.refresh"/>
                </button>
              </div>
            </div>

            <div className="form-group">
              <label
                htmlFor="upperMarginTime"
                className="col-md-3 control-label"
              >
                <FormattedMessage defaultMessage="Upper Margin Time (min.)" id="config.upper.time"/>
              </label>
              <div className="col-md-9">
                <input
                  className="form-control"
                  id="upperMarginTime"
                  type="number"
                  disabled={!hasPermission}
                  value={currentConfiguration.upperMarginTime}
                  name="upperMarginTime"
                  onChange={this.props.handleInputChange}
                />
              </div>
            </div>

            <div className="form-group">
              <label
                htmlFor="lowerMarginTime"
                className="col-md-3 control-label"
              >
                <FormattedMessage defaultMessage="Lower Margin Time (min.)" id="config.lower.time"/>
              </label>
              <div className="col-md-9">
                <input
                  className="form-control"
                  id="lowerMarginTime"
                  type="number"
                  disabled={!hasPermission}
                  value={currentConfiguration.lowerMarginTime || ''}
                  name="lowerMarginTime"
                  onChange={this.props.handleInputChange}
                />
              </div>
            </div>

            <div className="form-group">
              <label
                htmlFor="lowerMarginTime"
                className="col-md-3 control-label"
              >
                <FormattedMessage defaultMessage="Fix a date" id="config.fix.date"/>
              </label>
              <div className="col-md-9">
                <div className="checkbox">
                  <label>
                    <input
                      defaultChecked={currentConfiguration.dateMode || ''}
                      disabled={!hasPermission}
                      name="dateMode"
                      onChange={this.props.handleInputChange}
                      type="checkbox"
                    />
                  </label>
                </div>
              </div>
            </div>

            {currentConfiguration.dateMode && (
              <div className="form-group">
                <label
                  htmlFor="lowerMarginTime"
                  className="col-md-3 control-label"
                >
                  <FormattedMessage defaultMessage="Date" id="config.date"/>
                </label>
                <div className="col-md-9">
                  <DateTime
                    defaultValue={currentConfiguration.fixedDate}
                    locale="es"
                    inputProps={inputProps}
                    onBlur={this.props.handleDate}
                    dateFormat="YYYY-MM-DD"
                    timeFormat="HH:mm:ss"
                  />
                </div>
              </div>
            )}

            <div className="form-group">
              <label
                  htmlFor="validationEndpoint"
                  className="col-md-3 control-label"
              >
                <FormattedMessage defaultMessage="Validation Endpoint" id="config.validation.endpoint"/>
              </label>
              <div className="col-md-9">
                    <input
                        className="form-control"
                        name="validationEndpoint"
                        value={currentConfiguration.validationEndpoint || ''}
                        onChange={this.props.handleInputChange}
                        type="input"
                    />
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default GeneralTab;
